import { useAuth } from '../../contexts/AuthContext';

const OnboardingStep1Welcome = ({ onNext, isLoading }) => {
  const { user } = useAuth();

  return (
    <div className="onboarding-step welcome-content">
      <div className="welcome-icon">📖</div>
      
      <p>
        Welcome to readTheWord, {user?.name}! We're excited to help you track your Bible reading journey.
      </p>

      <ul className="welcome-features">
        <li>Log today's reading on Home</li>
        <li>Add family members as readers</li>
        <li>Create or join family groups</li>
        <li>View progress and statistics</li>
        <li>Choose from multiple Bible translations</li>
      </ul>

      <p>
        Let's get you set up with a quick 4-step process. You can skip any step and customize your settings later.
      </p>

      <div className="step-actions">
        <button 
          className="btn-primary"
          onClick={() => onNext()}
          disabled={isLoading}
        >
          {isLoading ? 'Loading...' : 'Get Started'}
        </button>
      </div>
    </div>
  );
};

export default OnboardingStep1Welcome;
